"use client";

import { useEffect, useState, useRef } from "react";


interface Metric {
  id: string;
  value: string;
  label: string;
  icon: string;
  description: string;
  color: string;
}

const MetricsPanel = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({
    volume: 0,
    clients: 0,
    delivery: 0,
    countries: 0,
  });
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const targets = {
      volume: 250,
      clients: 500,
      delivery: 99.8,
      countries: 15,
    };

    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    let step = 0;
    const timer = setInterval(() => {
      step++;
      const progress = step / steps;

      setCounts({
        volume: Math.floor(targets.volume * progress),
        clients: Math.floor(targets.clients * progress),
        delivery: Number((targets.delivery * progress).toFixed(1)),
        countries: Math.floor(targets.countries * progress),
      });

      if (step >= steps) {
        clearInterval(timer);
        setCounts(targets);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [isVisible]);

  const metrics: Metric[] = [
    {
      id: "metric_volume",
      value: `$${counts.volume}M+`,
      label: "Annual Trading Volume",
      icon: "CurrencyDollarIcon",
      description: "Processed through our platform annually",
      color: "text-primary",
    },
    {
      id: "metric_clients",
      value: `${counts.clients}+`,
      label: "Active Clients",
      icon: "UserGroupIcon",
      description: "Trusted partners worldwide",
      color: "text-accent",
    },
    {
      id: "metric_delivery",
      value: `${counts.delivery}%`,
      label: "On-Time Delivery",
      icon: "TruckIcon",
      description: "Industry-leading reliability",
      color: "text-success",
    },
    {
      id: "metric_countries",
      value: `${counts.countries}+`,
      label: "Countries Served",
      icon: "GlobeAltIcon",
      description: "Global trading network",
      color: "text-secondary",
    },
  ];

  return (
    <section data-component-id="src/app/homepage/components/MetricsPanel.tsx:113:4" data-component-path="src/app/homepage/components/MetricsPanel.tsx" data-component-line="113" data-component-end-line="133" data-component-file="MetricsPanel.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-24%20bg-gradient-to-b%20from-muted%2F30%20to-background%20relative%20overflow-hidden%22%7D"
      ref={sectionRef}
      className="py-24 bg-gradient-to-b from-muted/30 to-background relative overflow-hidden"
    >
      {/* Background Decoration */}
      <div data-component-id="src/app/homepage/components/MetricsPanel.tsx:118:6" data-component-path="src/app/homepage/components/MetricsPanel.tsx" data-component-line="118" data-component-end-line="127" data-component-file="MetricsPanel.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20opacity-5%22%7D" className="absolute inset-0 opacity-5">
        <div data-component-id="src/app/homepage/components/MetricsPanel.tsx:119:8" data-component-path="src/app/homepage/components/MetricsPanel.tsx" data-component-line="119" data-component-end-line="122" data-component-file="MetricsPanel.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-0%20left-0%20w-96%20h-96%20bg-primary%20rounded-full%20blur-3xl%22%7D"
          className="absolute top-0 left-0 w-96 h-96 bg-primary rounded-full blur-3xl"
          style={{ transform: "translate(-50%, -50%)" }}
        />
        <div data-component-id="src/app/homepage/components/MetricsPanel.tsx:123:8" data-component-path="src/app/homepage/components/MetricsPanel.tsx" data-component-line="123" data-component-end-line="126" data-component-file="MetricsPanel.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-0%20right-0%20w-96%20h-96%20bg-accent%20rounded-full%20blur-3xl%22%7D"
          className="absolute bottom-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl"
          style={{ transform: "translate(50%, 50%)" }}
        />
      </div>

      <div data-component-id="src/app/homepage/components/MetricsPanel.tsx:129:6" data-component-path="src/app/homepage/components/MetricsPanel.tsx" data-component-line="129" data-component-end-line="132" data-component-file="MetricsPanel.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container-custom%20relative%20z-10%22%7D" className="container-custom relative z-10">
        {/* Certifications */}
        {/* remove certifications div */}
      </div>
    </section>
  );
};

export default MetricsPanel;